/**
 * CMCD status header name.
 *
 *
 * @beta
 */
export const CMCD_STATUS = 'CMCD-Status'
